document.addEventListener('DOMContentLoaded', () => {
  const footer = document.querySelector('.shopify-section-group-footer-group:last-of-type');
  const stops = document.querySelectorAll('#watermarkGradient stop');
  const watermark = document.querySelector('.logo-watermark');
  const footerRight = document.querySelector('.footer-right');

  function updateGradient() {
    const rect = footer.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const total = rect.height;

    const scrolled = windowHeight - rect.top;

    let progress = Math.min(Math.max(scrolled / total, 0), 1);

    const value = progress * 100 + '%';

    stops[1].setAttribute('offset', value);
    stops[2].setAttribute('offset', value);

    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 50) {
      watermark.style.width = '49%';
      watermark.style.transition = 'width 0.8s ease';
      if (footerRight) footerRight.classList.add('visible');
    } else {
      watermark.style.width = '100%';
      if (footerRight) footerRight.classList.remove('visible');
    }
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth',
          });
        }
      });
    },
    {
      threshold: 0.4,
    }
  );

  observer.observe(footer);

  window.addEventListener('scroll', updateGradient);
  window.addEventListener('resize', updateGradient);
  updateGradient();
});
